import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../stores";
import { BUYER_HIDDEN_MESSAGE_ID } from "../utils/Constants";
import { Link } from "react-router-dom";

const DashboardModal = () => {
  const [hiddenModals, setHiddenModals] = useState<Set<number>>(new Set());
  const [visibleModals, setVisibleModals] = useState<Set<number>>(new Set()); // Track which modals are open

  const [language, setLanguage] = useState<"en" | "hi">(() => {
    const savedLanguage = localStorage.getItem("newsViewMode");
    return savedLanguage ? (savedLanguage as "en" | "hi") : "hi";
  });

  useEffect(() => {
    localStorage.setItem("newsViewMode", language);
  }, [language]);

  const { latestMessage } = useSelector((state: RootState) => state.profile);

  useEffect(() => {
    const hiddenData = localStorage.getItem(BUYER_HIDDEN_MESSAGE_ID);
    const hidden: number[] = hiddenData ? JSON.parse(hiddenData) : [];
    setHiddenModals(new Set(hidden));
  }, []);

  useEffect(() => {
    // Initially set all modals as visible if not hidden
    if (latestMessage && Array.isArray(latestMessage)) {
      const visible = new Set(
        latestMessage
          .filter((msg) => !hiddenModals.has(msg.id))
          .map((msg) => msg.id),
      );
      setVisibleModals(visible);
    }
  }, [latestMessage, hiddenModals]);

  const handleClose = (id: number) => {
    setVisibleModals((prev) => {
      const updated = new Set(prev);
      updated.delete(id);
      return updated;
    });
  };

  const handleNeverShowAgain = (id: number) => {
    const updatedHiddenModals = new Set(hiddenModals);
    updatedHiddenModals.add(id);
    setHiddenModals(updatedHiddenModals);
    localStorage.setItem(
      BUYER_HIDDEN_MESSAGE_ID,
      JSON.stringify(Array.from(updatedHiddenModals)),
    );
    handleClose(id);
  };

  const messages = Array.isArray(latestMessage) ? latestMessage : [];

  return (
    <>
      {messages
        .filter((msg) => visibleModals.has(msg.id)) // Only show modals that are still open
        .map((msg) => (
          <div key={msg.id}>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }}>
              <div
                className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered"
                role="document"
              >
                <div className="modal-content" style={{ height: "80vh" }}>
                  <div className="modal-header border-bottom-0 bg-primary">
                    <h4 className="text-white">
                      {language === "en"
                        ? "Today's Headlines"
                        : "आज की ताज़ा ख़बरें"}
                    </h4>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => handleClose(msg.id)}
                    />
                  </div>
                  <div
                    className="modal-body"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    <div
                      className="btn-group btn-group-toggle me-3"
                      data-toggle="buttons"
                    >
                      <label
                        className={`btn btn-outline-info btn-sm ${
                          language === "en" ? "active" : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="language"
                          className={"d-none"}
                          checked={language === "en"}
                          onChange={() => setLanguage("en")}
                        />{" "}
                        <i className={"fa fa-table-list"}></i>&nbsp;&nbsp;
                        <b>English</b>
                      </label>
                      <label
                        className={`btn btn-outline-info btn-sm ${
                          language === "hi" ? "active" : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="language"
                          className={"d-none"}
                          checked={language === "hi"}
                          onChange={() => setLanguage("hi")}
                        />{" "}
                        <i className={"fa fa-th"}></i>&nbsp;&nbsp;
                        <b>Hindi</b>
                      </label>
                    </div>
                    {language === "en" && (
                      <h6>
                        {msg?.content ? (
                          <div
                            dangerouslySetInnerHTML={{ __html: msg.content }}
                          />
                        ) : msg?.image ? (
                          <Link to={msg.image} target="_blank">
                            <img
                              src={msg.image}
                              alt="Content"
                              className="img-responsive"
                              style={{
                                display: "block",
                                margin: "auto", // Center horizontally
                                objectFit: "contain",
                                maxWidth: "100%",
                                maxHeight: "80vh", // Adjust this to fit the modal height
                              }}
                            />
                          </Link>
                        ) : (
                          <span>No content available</span>
                        )}
                      </h6>
                    )}
                    {language === "hi" && (
                      <h6>
                        {msg?.hindi_content ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: msg.hindi_content,
                            }}
                          />
                        ) : msg?.hindi_image ? (
                          <Link to={msg.hindi_image} target="_blank">
                            <img
                              src={msg.hindi_image}
                              alt="Content"
                              className="img-responsive"
                              style={{
                                display: "block",
                                margin: "auto", // Center horizontally
                                objectFit: "contain",
                                maxWidth: "100%",
                                maxHeight: "80vh", // Adjust this to fit the modal height
                              }}
                            />
                          </Link>
                        ) : (
                          <span>No content available</span>
                        )}
                      </h6>
                    )}
                  </div>
                  <div className="modal-footer py-2">
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={() => handleClose(msg.id)}
                    >
                      <b>Close</b>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary px-4"
                      onClick={() => handleNeverShowAgain(msg.id)}
                    >
                      <b>Do Not Show Again</b>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default DashboardModal;
